module.exports = __webpack_public_path__ + "img/1.3a883ebf.jpg";